import React, { useEffect, useState, useContext } from "react";
import { fetchJson } from "../fetch.js";
// import * as BookPageHelpers from './helpers.js';
import { initSwiperRelatedCarousels } from './helpers.js';
import * as Helpers from '../helpers.mjs';
import BookPackCollage from '../components/BookPackCollage.js';
import { SearchContext } from "../components/SearchContext.js";
import { useExtraData } from "./DataContext.js";
import { isNull, isEmpty } from "lodash";

const BookRelatedProductsCarousel = ({ carouselId, carouselType, carouselTitle }) => {
    let { _source, isGuestUser } = useExtraData();

    const disallowed = ["Agencies", "Artists", "Author", "Authors", "Authorities", "Authors of Some Repute", "Compiled", "Contributors", "Contributions", "Friends", "Hands", "Illustrators", "Kingstone Authors", "Musicians", "N/A", "Photographers", "photographers", "Poets", "Scholastic Inc", "Titan Comics", "Translators", "Writers"];

    const various = ["Various", "various", "Various Artists", "Various Authors", "Various Editors"];

    const r = _source;

    const { doSearchTermSearch } = useContext(SearchContext);

    const bindings = window.bindings;
    const broadbindings = window.broadbindings;

    const [getRelatedUrl, setRelatedUrl] = useState("");
    const [carouselTitleLinkText, setCarouselTitleLinkText] = useState("");

    const bookpageProductId = r.product_id;
    const bookpageProductEan13 = r.id;

    const bookpageAuthor = (carouselType == "ill" ? r.primary_author?.title : ""); // Used for filtering out products in illustrator carousel
    const bookpageSeries = ((carouselType == "auth" || carouselType == "ill") ? r.series_display : ""); // Used for filtering out products in author and/or illustrator carousels

    const [relatedData, setRelatedData] = useState([]);
    const [relatedExtraData, setRelatedExtraData] = useState([]);

    useEffect(() => {
        const filterProducts = (json) => {
            // Check if any products have been retrieved
            if(json.products?.hits?.hits) {
                // Get results that don't match book page product ID
                var results = json.products.hits.hits.filter(r => bookpageProductId != r._source.product_id);
                // Filter out products with the same series as the book page when required (e.g. if the series carousel is used)
                if (carouselType != "series" && !isNull(bookpageSeries) && !isEmpty(bookpageSeries)) {
                    results = results.filter(r => bookpageSeries != r._source.series_display);
                }
                // Filter out products with the same author as the book page when required (e.g. illustrator carousel shouldn't need to contain the same books as author carousel)
                if (carouselType != "auth" && !isNull(bookpageAuthor) && !isEmpty(bookpageAuthor)) {
                    results = results.filter(r => bookpageAuthor != r._source.primary_author.title);
                }
                // If carousel is for illustrator, filter to products with category 'JPIC'
                if (carouselType == "ill") {
                    results = results.filter(r => r._source.category == "JPIC");
                }
                // Set product data?
                setRelatedData(results);
                // Set product extra data? (e.g. display price & discount percentage)
                if (json.products.hits.total.value > 0) {
                    const items = json.products.hits.hits.reduce((acc, current) => {
                        acc[current._source.product_id] = {
                            dbdqtyheld: current._source.dbdqtyheld
                        };
                        return acc;
                    }, {});
                    fetchJson("/product/extraData", {
                        items: items
                    }).then((extra) => {
                        setRelatedExtraData(extra);
                    });
                }
            } else {
                // console.log("No products found");
                setRelatedData([]);
                setRelatedExtraData([]);
            }
        }

        const fetchRelatedData = () => {
            let getRelatedBooksUrl = "";
            let getRelatedBookPacksUrl = "";

            switch (carouselType) {
                case "auth":
                    // TEMP primary_author_nat FIX HOPEFULLY 
                    const primaryAuthorNames = (r.primary_author ? r.primary_author.title.split(",") : []);
                    const primaryAuthorFirstName = primaryAuthorNames.pop();
                    const primaryAuthorNameNat = primaryAuthorFirstName.trim() + " " + primaryAuthorNames.join(", ").trim();

                    if(!disallowed.includes(r.primary_author?.title.trim()) && !various.includes(r.primary_author?.title.trim())){
                        getRelatedBooksUrl = encodeURI("/product/getRelatedByAuthor?author=" + r.primary_author?.value);
                        setCarouselTitleLinkText(primaryAuthorNameNat);
                    }
                    break;
                case "ill":
                    // TEMP primary_illustrator_nat FIX HOPEFULLY 
                    const primaryIllusNames = (r.primary_illustrator ? r.primary_illustrator.title.split(",") : []);
                    const primaryIllusFirstName = primaryIllusNames.pop();
                    const primaryIllusNameNat = primaryIllusFirstName.trim() + " " + primaryIllusNames.join(", ").trim();

                    if(!disallowed.includes(r.primary_illustrator?.title.trim()) && !various.includes(r.primary_illustrator?.title.trim())){
                        getRelatedBooksUrl = encodeURI("/product/getRelatedByIllustrator?illustrator=" + r.primary_illustrator?.value);
                        setCarouselTitleLinkText(primaryIllusNameNat);
                    }
                    break;
                case "series":
                    getRelatedBooksUrl = encodeURI(`/product/getRelatedBySeries?series=${r.series_display}`);
                    setCarouselTitleLinkText(r.series_display);
                    break;
                case "bookListId":
                    getRelatedBookPacksUrl = encodeURI(`/product/getRelatedByBookListId?ean13=${bookpageProductEan13}`);
                    setRelatedUrl(getRelatedBookPacksUrl);
                case "bookPack":
                    getRelatedBookPacksUrl = encodeURI(`/product/getRelatedBookPacks?origin="${r.origin}"&type="${r.type}"&subtype="${r.subtype !== undefined ? r.subtype : ''}"`);
                    break;
                case "isbnList":
                    getRelatedBooksUrl = encodeURI(`/product/getBookPackContents?isbnArray=[${r.primary_candidates}]`);
                    setRelatedUrl(getRelatedBooksUrl);
                    setCarouselTitleLinkText(carouselTitle);
                    break;
            }

            if (getRelatedBooksUrl !== "") {
                fetchJson(getRelatedBooksUrl).then((json) => {
                    filterProducts(json);
                });
            } else if (getRelatedBookPacksUrl !== "") {
                fetchJson(getRelatedBookPacksUrl).then((json) => {
                    if(json.products?.hits?.hits) {
                        // Get results that don't match book page product ID
                        var results = json.products.hits.hits.filter(r => bookpageProductEan13 != r._source.id);
                        // Display title of book list?
                        if (!isEmpty(json.carouselLinkTitle)) {
                            setCarouselTitleLinkText(json.carouselLinkTitle);
                        }
                        // Set product data?
                        setRelatedData(results);
                    } else {
                        setRelatedData([]);
                    }
                }).then(() => {
                    setRelatedExtraData([]); // EXTRA DATA NO LONGER REQUIRED FOR BOOK PACKS?
                });
            } else {
                // console.log("No url found");
                setRelatedData([]);
                setRelatedExtraData([]);
            }
        }
    
        // TODO: If carousel is for series, sort by volume (can sometimes include other series due to match query)
        const sortResults = (products) => {
            if (products && products.hits && products.hits.total.value > 0) {
                var currentData = products.hits.hits;
                var sortedData = [];
                // Get all distinct series from carousel
                const seriesList = [...new Set(currentData.map(hit => hit._source.series_display))];
                seriesList.map(r => {
                    // Get number of volumes from series
                    const seriesProductsArray = currentData.filter(hit => hit._source.series_display == r);
                    const volumeArray = seriesProductsArray.map(hit => hit._source.volume);
                    const volumeCount = volumeArray.filter(volume => volume != 0).length;
                    // If number of volumes is less than 5, sort ASC
                    if (volumeCount < 5) {
                        const sortedAsc = seriesProductsArray.sort((a, b) => a._source.volume - b._source.volume);
                        sortedAsc.map(s => sortedData.push(s));
                    }
                    // If number of volumes is more than 5, sort DESC
                    else {
                        const sortedDesc = seriesProductsArray.sort((a, b) => b._source.volume - a._source.volume);
                        sortedDesc.map(s => sortedData.push(s));
                    }
                });
                // return (sortedData.length > 0 ? sortedData : currentData);
            }
        };

        fetchRelatedData();
    }, [bookpageProductId]);

    useEffect(() => {
        if (!window.swiper) {
            window.swiper = [];
        }
        
        if (!window.isIE) {
            initSwiperRelatedCarousels();
        }
    }, [relatedData]);

    const CarouselHeader = ({title, type}) => {
        return (
            <>
                <div className="recommendedHeader">
                    {type !== "isbnList" && title !== "" && <><h3>{title}</h3></>}
                    {type !== "bookPack" ? (carouselTitleLinkText !== "" && <>
                        <h3><a onClick={e => {
                            switch (type) {
                                case "bookListId":
                                    // If carousel is for displaying other book packs, then navigate to search results by book list (e.g. Library packs) -> ORIGINAL VERSION?
                                    break;
                                case "isbnList":
                                    // If carousel is for displaying the contents of a book pack, then navigate to search results by ISBN list?
                                    fetchJson(getRelatedUrl).then((json) => {
                                        window.location.href = "/search-results/" + json.encodedQuery;
                                    });
                                    break;
                                default:
                                    // If carousel is for displaying related books, navigate to search results by author/illustrator/series?
                                    e.preventDefault();
                                    doSearchTermSearch(carouselTitleLinkText, type);
                                    break;
                            }
                        }}>{carouselTitleLinkText}</a></h3>
                    </>) :
                    (carouselTitleLinkText !== "" && <>
                        <h3>&nbsp;<span>{carouselTitleLinkText}</span></h3>
                    </>)}
                </div>
            </>
        )
    }

    return (
        <>
            {!isNull(relatedData) && relatedData.length > 0 && <div id={carouselId} className="recommendedSection relatedProducts" slidetoshowcount="8" data-slides={relatedData.length}>
                <CarouselHeader title={carouselTitle} type={carouselType} />
                <div className="swiper-container">
                    <button type="button" className="swiper-button swiper-button-prev"></button>
                    <div className="swiper-wrapper">
                        {relatedData.map((r, i) => {
                            const productDetails = r._source;
                            const productImage = Helpers.getProductImageLink(productDetails.id);

                            const elasticIndex = r._index;
                            const isBookPackItem = (elasticIndex.includes("dyn_book_packs"));

                            var creators = [];
                            if (!isBookPackItem) {
                                productDetails.main_contributors?.authors?.map(a => creators.push(a));
                                productDetails.main_contributors?.illustrators?.map(i => creators.push(i));
                            }

                            let matchingItem = {};
                            if (!isNull(relatedExtraData)) {
                                matchingItem = relatedExtraData[productDetails.product_id];
                            }
                            
                            return (
                                <div key={`bookRelatedProductsCarousel${i}`} className="swiper-slide recommendedContainer">
                                    <div className={`recommendedImageContainer${isBookPackItem ? " isBookPack" : ""}`}>
                                        <div className={isBookPackItem ? "recommendedBookPackImage":"recommendedImage"}>
                                            <a href={`/book-page/${productDetails.id}`}>
                                                {isBookPackItem ? <BookPackCollage source={productDetails} /> : <img className="bookImg swiper-lazy lazyload" onError={(e) => { Helpers.handleImageError(e) }} src={productImage} data-src={productImage} data-backup-src={productImage} title="" alt={Helpers.decodeHTML(`${productDetails.title}`)} />}
                                                <div className={isBookPackItem ? "bookPackContainer" : "bookHover"}>
                                                    {!isBookPackItem && <p>
                                                        {!isGuestUser && !isNull(productDetails.evaluation) && !isEmpty(productDetails.evaluation) ? 
                                                        (productDetails.evaluation.length > 150 ? (productDetails.evaluation.substring(0, 150).trim() + "...") : productDetails.evaluation) : 
                                                        (!!productDetails.annotation ? (productDetails.annotation.length > 150 ? (productDetails.annotation.substring(0, 150).trim() + "...") : productDetails.annotation) : <>
                                                            {Helpers.decodeHTML(`${productDetails.title}${productDetails.subtitle && `&#58;&nbsp;${productDetails.subtitle}`}`)}
                                                            {!isNull(creators) && creators.length > 0 && <>
                                                                <br />
                                                                <br />
                                                                {creators.map((c, index) => { return `${c}${(index === (creators.length-2) ? " and " : (index !== (creators.length-1) && creators.length>1 ? ", " : ""))}` })}
                                                            </>}
                                                        </>)}
                                                    </p>}
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="recommendedBookDetails">
                                        <div className="carouselBookTitle">
                                            <a href={`/book-page/${productDetails.id}`}>
                                                <span>
                                                    {!isBookPackItem ? Helpers.decodeHTML(`${productDetails.title}${productDetails.subtitle && `&#58;&nbsp;${productDetails.subtitle}`}`) : Helpers.decodeHTML(`${productDetails.title}`)}
                                                    {carouselType == "series" && productDetails.volume && <>&nbsp;({productDetails.volume})</>}
                                                </span>
                                                <br />
                                                {productDetails.binding && (bindings[productDetails.binding] == "Board book" || bindings[productDetails.binding] == "Board") ? <span>(Board book)</span> : (productDetails.broad_binding && broadbindings[productDetails.broad_binding] != "Other" ? <span>({broadbindings[productDetails.broad_binding]})</span> : (productDetails.binding == 'PK' && productDetails.distributor.value == "9ZZ8" ? <span>(Peters pack)</span> : (productDetails.binding && <span>({bindings[productDetails.binding]})</span>)))}
                                            </a>
                                        </div>
                                        {isBookPackItem ? <>
                                            <p className="homePrice">{Helpers.currency(productDetails.min_price)}</p>
                                            {productDetails.discount > 0 ? <div className="homePriceSection">
                                                <p className="rrpHome">RRP&nbsp;{Helpers.currency(productDetails.min_price / (1 - productDetails.discount))}</p>
                                                <p className="savingHome">Save {(100 * productDetails.discount)}%</p>
                                            </div> : <div>&nbsp;</div>}
                                        </> : <>
                                            <p className="homePrice">{!isNull(relatedExtraData) && matchingItem !== undefined ? Helpers.currency(matchingItem["price"]) : Helpers.currency(productDetails.rrp)}</p>
                                            {!isNull(relatedExtraData) && matchingItem !== undefined && matchingItem["discount"] > 0 ? <div className="homePriceSection">
                                                <p className="rrpHome">RRP&nbsp;{Helpers.currency(productDetails.rrp)}</p>
                                                <p className="savingHome">Save {matchingItem["discount"]}%</p>
                                            </div> : <div>&nbsp;</div>}
                                        </>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <button type="button" className="swiper-button swiper-button-next"></button>
                </div>
                <div className="recommendedFooter"></div>
            </div>}
        </>
    )
}

export default BookRelatedProductsCarousel;